import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import GlobelStore from "../../../Store/GlobelStore";
import RadialBarChart from "../../../components/Chart/RadialBarChart";
import { observer } from "mobx-react";

const EmployeeChartCareAid = observer(() => {
  const [seriesData, setSeriesData] = useState([
    {
      title: "PCA",
      total: 0,
      active: 0,
      notWorking: 0,
    },
    {
      title: "RN",
      total: 0,
      active: 0,
      notWorking: 0,
    },
    {
      title: "CNA",
      total: 0,
      active: 0,
      notWorking: 0,
    },
    {
      title: "CMT",
      total: 0,
      active: 0,
      notWorking: 0,
    },
  ]);
  useEffect(() => {
    const careGiverData = GlobelStore?.dashboardAllData?.careGiverData;
    if (careGiverData) {
      setSeriesData(careGiverData);
    }
  }, [GlobelStore?.dashboardAllData?.careGiverData]);

  const rnData = seriesData.find((item) => item.title === "RN");
  const pcaData = seriesData.find((item) => item.title === "PCA");
  const cnaData = seriesData.find((item) => item.title === "CNA");
  const cmtData = seriesData.find((item) => item.title === "CMT");

  return (
    <div className="EmployeeChartMainContainer">
      <div className="titleContainer">
        <div className="title">Personal Care Aid</div>
        <div className="total">
          Total:
          {rnData?.total + pcaData?.total + cnaData?.total + cmtData?.total}
        </div>
      </div>
      <div className="InfoboxRadialBarContainer">
        <div id="chart">
          <RadialBarChart seriesData={seriesData} />
        </div>
        <div className="statsContainerEmpChart">
          <div className="statItemEmpChart">
            <div className="statItemIconTitleDiv">
              <div className="statIcon purple">
                <span role="img" aria-label="sales">
                  ⏱️
                </span>
              </div>
              <div className="statTitle">{rnData?.title}</div>
            </div>

            <div className="subDetailContainer">
              <div className="detailTitleTotal">Total:</div>
              <div className="detailValueTotal">{rnData?.total}</div>
            </div>
            <div className="subDetailContainer">
              <div className="detailTitleActive">Active:</div>
              <div className="detailValueActive ">{rnData?.active}</div>
            </div>
            <div className="subDetailContainer">
              <div className="detailTitleNotWorking">Not Working:</div>
              <div className="detailValueNotWorking">{rnData?.notWorking}</div>
            </div>
          </div>
          <div className="statItemEmpChart">
            <div className="statItemIconTitleDiv">
              <div className="statIcon purple">
                <span role="img" aria-label="sales">
                  ⏱️
                </span>
              </div>
              <div className="statTitle">{pcaData?.title}</div>
            </div>

            <div className="subDetailContainer">
              <div className="detailTitleTotal">Total:</div>
              <div className="detailValueTotal">{pcaData?.total}</div>
            </div>
            <div className="subDetailContainer">
              <div className="detailTitleActive">Active:</div>
              <div className="detailValueActive ">{pcaData?.active}</div>
            </div>
            <div className="subDetailContainer">
              <div className="detailTitleNotWorking">Not Working:</div>
              <div className="detailValueNotWorking">{pcaData?.notWorking}</div>
            </div>
          </div>
          <div className="statItemEmpChart">
            <div className="statItemIconTitleDiv">
              <div className="statIcon purple">
                <span role="img" aria-label="sales">
                  ⏱️
                </span>
              </div>
              <div className="statTitle">{cnaData?.title}</div>
            </div>

            <div className="subDetailContainer">
              <div className="detailTitleTotal">Total:</div>
              <div className="detailValueTotal">{cnaData?.total}</div>
            </div>
            <div className="subDetailContainer">
              <div className="detailTitleActive">Active:</div>
              <div className="detailValueActive ">{cnaData?.active}</div>
            </div>
            <div className="subDetailContainer">
              <div className="detailTitleNotWorking">Not Working:</div>
              <div className="detailValueNotWorking">{cnaData?.notWorking}</div>
            </div>
          </div>
          <div className="statItemEmpChart">
            <div className="statItemIconTitleDiv">
              <div className="statIcon purple">
                <span role="img" aria-label="sales">
                  ⏱️
                </span>
              </div>
              <div className="statTitle">{cmtData?.title}</div>
            </div>

            <div className="subDetailContainer">
              <div className="detailTitleTotal">Total:</div>
              <div className="detailValueTotal">{cmtData?.total}</div>
            </div>
            <div className="subDetailContainer">
              <div className="detailTitleActive">Active:</div>
              <div className="detailValueActive ">{cmtData?.active}</div>
            </div>
            <div className="subDetailContainer">
              <div className="detailTitleNotWorking">Not Working:</div>
              <div className="detailValueNotWorking">{cmtData?.notWorking}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default React.memo(EmployeeChartCareAid);
